import { useTranslation } from "react-i18next";
import { Building, Store, Home } from "lucide-react";

const ENTITY_META = {
  subsidiary: { icon: Building, color: "bg-indigo-600" },
  branch:     { icon: Store,    color: "bg-fuchsia-500" },
};

// رأس تبويب الأساسيات: نوع الكيان + المركز الرئيسي (مفصول للحفاظ على حدّ 100 سطر).
export const BasicsHeader = ({ form, set }) => {
  const { t } = useTranslation();
  const entity = form.entity_type || "branch";

  return (
    <>
      <div className="sm:col-span-2">
        <p className="label-xs mb-2">{t("branches.entityType")}</p>
        <div className="grid grid-cols-2 gap-2">
          {["subsidiary", "branch"].map((key) => {
            const { icon: Icon, color } = ENTITY_META[key];
            const active = entity === key;
            return (
              <button key={key} type="button" data-testid={`branch-entity-${key}`}
                onClick={() => set("entity_type", key)}
                className={`flex items-center gap-2 rounded-3xl bg-background px-3 py-2.5 transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5 ${
                  active ? "shadow-neu-in text-primary" : "shadow-neu-sm hover:shadow-neu text-foreground"
                }`}>
                <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-white shadow-neu-sm ${color}`}>
                  <Icon className="h-5 w-5" strokeWidth={2.4} />
                </span>
                <span className="text-[12px] font-bold">{t(`branches.entity.${key}`)}</span>
              </button>
            );
          })}
        </div>
      </div>
      <div className="sm:col-span-2">
        <p className="label-xs mb-2">{t("branches.headOffice")}</p>
        <button type="button" data-testid="branch-head-office-toggle"
          onClick={() => set("is_head_office", !form.is_head_office)}
          className={`flex items-center gap-2 rounded-3xl bg-background px-3 py-2.5 transition-[box-shadow,transform] duration-300 hover:-translate-y-0.5 ${
            form.is_head_office ? "shadow-neu-in text-primary" : "shadow-neu-sm hover:shadow-neu text-foreground"
          }`}>
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-500 text-white shadow-neu-sm">
            <Home className="h-5 w-5" strokeWidth={2.4} />
          </span>
          <span className="text-[12px] font-bold">{form.is_head_office ? t("branches.isHeadOffice") : t("branches.setHeadOffice")}</span>
        </button>
        <p className="mt-1 text-xs text-muted-foreground">{t("branches.headOfficeHint")}</p>
      </div>
    </>
  );
};
